// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Notifications settings — tavern theme */

.notifications-page {
  padding: var(--space-4);
  max-width: 640px;
  margin: 0 auto;
}

.notifications-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.notifications-back {
  min-height: 44px;
  background: rgba(245, 239, 231, 0.12);
  border: 1px solid var(--color-parchment-300);
  border-radius: var(--radius-lg);
  color: var(--color-parchment-100);
  padding: var(--space-2) var(--space-3);
  font-family: var(--font-body);
  cursor: pointer;
}

.notifications-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.notifications-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-3);
  padding: var(--space-4);
  background: var(--color-parchment-200);
  border: 2px solid var(--color-fire-600);
  border-radius: var(--radius-lg);
}

.notifications-banner-text {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
  flex: 1 1 200px;
  color: var(--color-text-primary);
  font-size: 13px;
  line-height: 1.4;
}

.notifications-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background: var(--color-parchment-100);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
}

.notifications-summary-count {
  color: var(--color-text-primary);
  font-weight: 700;
}

.notifications-summary-hint {
  margin-top: var(--space-1);
  color: var(--color-text-secondary);
  font-size: 12px;
}

.notifications-link-button {
  min-height: 44px;
  padding: 0 var(--space-2);
  background: none;
  border: none;
  color: var(--color-fire-600);
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.notifications-link-button:disabled {
  opacity: 0.6;
  cursor: default;
}

.notifications-link-button:focus-visible {
  outline: 3px solid var(--tg-theme-link-color, #2481cc);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

.notifications-section {
  background: var(--color-parchment-100);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.notifications-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-3) var(--space-4);
  background: var(--color-parchment-200);
  border-bottom: 1px solid var(--color-wood-500);
}

.notifications-section-copy {
  min-width: 0;
}

.notifications-section-title {
  margin: 0;
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: 700;
  color: var(--color-wood-700);
}

.notifications-section-description {
  margin-top: var(--space-1);
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.4;
}

.notifications-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.notifications-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  min-height: 56px;
  padding: var(--space-2) var(--space-4);
}

.notifications-row + .notifications-row {
  border-top: 1px solid rgba(139, 105, 20, 0.2);
}

.notifications-row-copy {
  min-width: 0;
}

.notifications-row-title {
  color: var(--color-text-primary);
  font-weight: 600;
}

.notifications-row-description {
  margin-top: 2px;
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.4;
}

.notifications-note {
  margin: 0 0 var(--space-4);
  color: var(--color-text-tertiary);
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Notifications/NotificationsPage.css"],"names":[],"mappings":"AAEA,0CAA0C;;AAE1C;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4CAA4C;EAC5C,+BAA+B;EAC/B,iCAAiC;EACjC,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@import '../_base.css';\n\n/* Notifications settings — tavern theme */\n\n.notifications-page {\n  padding: var(--space-4);\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n.notifications-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n}\n\n.notifications-back {\n  min-height: 44px;\n  background: rgba(245, 239, 231, 0.12);\n  border: 1px solid var(--color-parchment-300);\n  border-radius: var(--radius-lg);\n  color: var(--color-parchment-100);\n  padding: var(--space-2) var(--space-3);\n  font-family: var(--font-body);\n  cursor: pointer;\n}\n\n.notifications-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n.notifications-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  background: var(--color-parchment-200);\n  border: 2px solid var(--color-fire-600);\n  border-radius: var(--radius-lg);\n}\n\n.notifications-banner-text {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 0;\n  flex: 1 1 200px;\n  color: var(--color-text-primary);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.notifications-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3);\n  padding: var(--space-3) var(--space-4);\n  background: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n}\n\n.notifications-summary-count {\n  color: var(--color-text-primary);\n  font-weight: 700;\n}\n\n.notifications-summary-hint {\n  margin-top: var(--space-1);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n}\n\n.notifications-link-button {\n  min-height: 44px;\n  padding: 0 var(--space-2);\n  background: none;\n  border: none;\n  color: var(--color-fire-600);\n  font-family: var(--font-body);\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.notifications-link-button:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.notifications-link-button:focus-visible {\n  outline: 3px solid var(--tg-theme-link-color, #2481cc);\n  outline-offset: 2px;\n  border-radius: var(--radius-sm);\n}\n\n.notifications-section {\n  background: var(--color-parchment-100);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.notifications-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-3) var(--space-4);\n  background: var(--color-parchment-200);\n  border-bottom: 1px solid var(--color-wood-500);\n}\n\n.notifications-section-copy {\n  min-width: 0;\n}\n\n.notifications-section-title {\n  margin: 0;\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--color-wood-700);\n}\n\n.notifications-section-description {\n  margin-top: var(--space-1);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.notifications-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.notifications-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  min-height: 56px;\n  padding: var(--space-2) var(--space-4);\n}\n\n.notifications-row + .notifications-row {\n  border-top: 1px solid rgba(139, 105, 20, 0.2);\n}\n\n.notifications-row-copy {\n  min-width: 0;\n}\n\n.notifications-row-title {\n  color: var(--color-text-primary);\n  font-weight: 600;\n}\n\n.notifications-row-description {\n  margin-top: 2px;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.notifications-note {\n  margin: 0 0 var(--space-4);\n  color: var(--color-text-tertiary);\n  font-size: 12px;\n  line-height: 1.5;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
